module.exports = __webpack_public_path__ + "static/sports-ed9aaf4e0cbc4d79c51c4a12a42844cd.png";